import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { FinancePermissions } from './permissions'

function guarded(
  perm: string | readonly string[],
  Page: ComponentType,
  mode: 'all' | 'any' = 'any',
): ComponentType {
  return createPermissionGuardedPage(perm, Page, { mode, administratorBypass: true })
}

export const financeRoutes: RouteObject[] = [
  {
    path: 'finance',
    children: [
      {
        index: true,
        lazy: async () => ({
          Component: guarded(
            FinancePermissions.workspaceAccess,
            (await import('./pages/finance-overview-page')).FinanceOverviewPage,
            'any',
          ),
        }),
      },
      {
        path: 'movements',
        lazy: async () => ({
          Component: guarded(
            FinancePermissions.workspaceAccess,
            (await import('./pages/finance-movements-page')).FinanceMovementsPage,
            'any',
          ),
        }),
      },
    ],
  },
]
